import css from 'styled-jsx/css';

const styles = css.global`#emp-garantia-carro-saber {
  padding: 32px 0;
  background: #FBFBFB;
}

#emp-garantia-carro-saber .ctn-home-24 {
  display: flex;
  flex-direction: column;
  gap: 48px;
}

#emp-garantia-carro-saber .saber-conteudo {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

#emp-garantia-carro-saber .saber-conteudo .saber-titulo {
  margin: 0;
  color: #444;
  font-family: "SantanderHeadline";
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 36px;
}

#emp-garantia-carro-saber .saber-conteudo .saber-itens {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

#emp-garantia-carro-saber .saber-conteudo .saber-item {
  color: #444;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
}

#emp-garantia-carro-saber .saber-conteudo .saber-item b {
  color: #C00;
  font-family: "SantanderText";
  font-size: 32px;
  font-style: normal;
  font-weight: 600;
  line-height: 48px; 
}

#emp-garantia-carro-saber .saber-card {
  display: flex;
  padding: 32px 16px;
  flex-direction: column;
  gap: 16px;
  border-radius: 4px;
  background: #DEEDF2;
}

#emp-garantia-carro-saber .saber-card-titulo {
  color: #444;
  font-family: "SantanderHeadline";
  font-size: 40px;
  font-style: normal;
  font-weight: 400;
  line-height: 60px;
}

#emp-garantia-carro-saber .saber-card-texto {
  color: #444;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  flex: 1;
}

@media (min-width: 992px) {
  #emp-garantia-carro-saber {
    padding: 48px 0 64px; 
  }

  #emp-garantia-carro-saber .saber-conteudo .saber-titulo {
    font-size: 32px;
    line-height: 48px;
  }

  #emp-garantia-carro-saber .saber-card {
    padding: 34px 48px;
    flex-direction: row;
    gap: 56px;
    align-items: center;
  }

}`;

export default styles;